import '@uppy/core/dist/style.min.css'
import '@uppy/dashboard/dist/style.min.css'

import { Controller } from "stimulus";
import tippy from 'tippy.js';
import Uppy from "@uppy/core"
import Portuguese from "@uppy/locales/lib/pt_BR"
import Dashboard from "@uppy/dashboard"
import * as ActiveStorage from "@rails/activestorage";
import prettyBytes from 'pretty-bytes';

import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';
import Swal from 'sweetalert2';
import ActiveStorageUpload from '../entrypoints/src/lib/uppy_activestorage_upload';

export default class extends Controller {
  static targets = ['emptyMessage', 'attachmentsTable'];

  connect() {
    this.$files = this.element.querySelector('.files');
    this.updateFilesContainer();

    ActiveStorage.start();
    this.setUppy();

    new MutationObserver(() => this.updateFilesContainer()).observe(this.$files, { subtree: true, childList: true });

    return this;
  }

  updateFilesContainer() {
    let attachmentsLength = this.$files.querySelectorAll('.attachment').length;
    this.emptyMessageTarget.classList.toggle('hidden', attachmentsLength > 0);
    this.attachmentsTableTarget.classList.toggle('hidden', attachmentsLength == 0);
  }

  setUppy() {
    let trigger = this.element.querySelector('[data-behavior="uppy-trigger"]');
    let directUploadURL = document.querySelector("meta[name='direct-upload-url']").getAttribute("content");
    let fieldName = this.element.dataset.uppy;

    if (!trigger)
      return;

    trigger.addEventListener("click", (event) => event.preventDefault());

    // Per-file limit rendered by the partial from AttachmentSizeLimit (server side); Uppy refuses a
    // bigger file before any transfer. No attribute, no cap.
    const maxFileSize = Number(this.element.dataset.maxFileSize) || null;

    let uppy = new Uppy({
      debug: false,
      locale: Portuguese,
      autoProceed: true,
      allowMultipleUploads: true,
      restrictions: { maxFileSize }
    })

    uppy.use(ActiveStorageUpload, {
      directUploadUrl: directUploadURL
    })

    // The Dashboard informer is disabled: refusals are reported by SweetAlert, the system pattern
    // (the informer also renders clipped inside this app's layout).
    uppy.use(Dashboard, {
      trigger: trigger,
      closeAfterFinish: true,
      disableInformer: true,
      note: this.element.dataset.maxFileSizeNote
    });

    uppy.on('restriction-failed', (file, error) => this.reportRefusedFile(file, error));
    uppy.on('upload-success', (file, response) => {
      this.setPreview(file, response, fieldName);
    })
  }

  // Uppy checks every file of a selection in one go: gather the refused names and warn once.
  reportRefusedFile(file, error) {
    this.refusedFiles = (this.refusedFiles || []).concat(file ? [file.name] : []);
    this.refusedError = error;
    clearTimeout(this.refusedTimer);
    this.refusedTimer = setTimeout(() => {
      const names = this.refusedFiles.join(', ');
      const message = this.element.dataset.maxFileSizeMessage;
      this.refusedFiles = [];
      Swal.fire({ icon: 'warning', text: message && names ? message.replace('{{filename}}', names) : this.refusedError.message });
    }, 0);
  }

  setPreview(file, response, fieldName) {
    const attachHTML = `
      <tr class="attachment">
        <td>
          <input type="hidden" name="${fieldName}" value="${response.signed_id}" data-pending-upload="true">
          ${file.name}
        </td>
        ${
          this.element.dataset.table === 'basic' ? '' : `
          <td>${prettyBytes(file.size)}</td>
          <td>${response.created_at}</td>
          <td>
            <span class="text-muted text-sm">Salve para mudar...</span>
          </td>
        `}
        <td>
          <a href="javascript: void(0)" class="remove-file text-danger text-sm">remover</a>
        </td>
      </tr>
    `;
    this.attachmentsTableTarget.insertAdjacentHTML('beforeend', attachHTML);

    let lastFile = this.attachmentsTableTarget.querySelector('.attachment:last-child'),
      removeFile = lastFile.querySelector('.remove-file');

    tippy(lastFile.querySelectorAll('[data-tippy-content]'), {
      allowHTML: true,
      animation: 'scale',
      interactive: true,
      theme: 'traus-light',
      appendTo: document.body
    });

    !!removeFile && removeFile.addEventListener('click', (ev) => {
      ev.preventDefault();
      const attachment = ev.currentTarget.closest('.attachment');
      Swal.fire({
        title: 'Atenção',
        icon: 'warning',
        html: 'Deseja realmente remover esse arquivo?',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Sim!',
        cancelButtonText: 'Não',
      }).then((result) => {
        result.value && attachment.remove();
      });
    });
  }
}